import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../utils/SEO";

export default function ItalyNonDomTaxRegime() {

    return (
        <main className='main'>
            <SEO
                title="Italy Non-Dom Tax | €100K Flat Tax Regime "
                description="Benefit from Italy’s Non-Dom tax regime with €100K flat tax on global income, up to 15 years, and family inclusion for tax efficiency. "
                keywords="Italy non dom tax, Italy flat tax regime, Italy €100k tax scheme, Italy tax residency, high net worth tax Italy, Italy foreign income tax, Italy expat tax benefits, global income tax Italy "
                url="/italy-non-dom-tax-regime"
            />
            <IntroSection
                title="Italy Non-Dom Tax Regime"
                subtitle="€100,000 Flat Tax on Global Income"
                description="Italy offers one of Europe’s most appealing Non-Domiciled (Non-Dom) tax regimes, tailored for high-net-worth individuals, entrepreneurs, and globally mobile families. By becoming an Italian tax resident, you can elect to pay a flat €100,000 annual tax on all foreign-sourced income, regardless of amount, with the option to extend benefits to family members. This regime provides a powerful combination of lifestyle, tax efficiency, and long-term planning advantages."
                badges={[
                    "€100k Flat Tax",
                    "Up to 15 Years",
                    "Family Members Included"
                ]}
                buttonText="Request an Italy Non-Dom Consultation →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/non-dom-tax-regim/italy-non-dom.png')}
                imageAlt="Italy Non-Dom Tax Regime"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Who Qualifies?"
                        blocks={[
                            {
                                items: [
                                    { text: "Individuals who have not been tax resident in Italy for 9 of the previous 10 years." },
                                    { text: "Must transfer tax residency to Italy (stay at least 183 days per year)." },
                                    { text: "Popular among entrepreneurs, investors, celebrities, and retirees relocating to Italy." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Key Benefits of Italy Non-Dom Status"
                        blocks={[
                            {
                                items: [
                                    { text: "Flat €100,000 annual tax on all foreign income and gains." },
                                    { text: "Family Coverage — add family members for €25,000 per year each." },
                                    { text: "Duration — regime available for up to 15 years." },
                                    { text: "Inheritance & Gift Tax Relief — non-Italian assets excluded." },
                                    {
                                        text:
                                            "Flexibility — can be combined with Italian real estate investments, company formation, or the Italy Investor Visa."
                                    }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Practical Uses"
                        blocks={[
                            {
                                items: [
                                    { title: "Protect Offshore Income", text: "Maintain global income streams with tax certainty." },
                                    { title: "Combine With Italy Residency", text: "Compatible with the Italy Investor Visa or Elective Residency." },
                                    { title: "Lifestyle Relocation", text: "Live in Italy while benefiting from predictable taxation." },
                                    { title: "Estate Planning", text: "Offshore assets remain outside Italian inheritance tax scope." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Example Scenario"
                        blocks={[
                            {
                                items: [
                                    {
                                        text:
                                            "A global investor relocating to Milan earns €10M per year abroad. Under the Italy Non-Dom regime, they pay only a €100,000 flat tax annually regardless of income size. Their spouse can be added for an additional €25,000."
                                    }
                                ]
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Interested in relocating to Italy under the Non-Dom tax regime?"
                        description="Offshore Advisory provides comprehensive support for Non-Dom applications, residency, and investment structuring."
                        buttonText="Book an Italy Non-Dom Consultation Today →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How long does Italy Non-Dom status last?",
        answer: "Up to 15 years.",
    },
    {
        question: "Can my family benefit?",
        answer: "Yes, each family member can be included for €25,000 per year.",
    },
    {
        question: "Do I need to invest in Italy?",
        answer: "No minimum investment is required, but relocating and showing ties (such as property purchase) strengthens applications.",
    },
    {
        question: "Do I still pay tax on Italian income?",
        answer: "Yes, Italian-sourced income is taxed normally. The €100k flat tax only covers foreign income.",
    },
    {
        question: "Can this be combined with Italian residency programs?",
        answer: "Yes – it works well with the Investor Visa, Elective Residency Visa, or property ownership.",
    },
];

